import React from "react";
export default function WorkFlow_4_Icon(fillColor) {
  return (
    <div style={{ marginRight: "8px" }}>
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          y="0.28125"
          width="24"
          height="24"
          rx="12"
          fill={fillColor.color}
        />
        <path
          d="M12.6055 17.2812H13.8086V15.2373H15.21V14.1367H13.8086V7.41699H12.0244C10.6436 9.47461 9.13281 11.8809 7.7998 14.1162V15.2373H12.6055V17.2812ZM9.05762 14.1436V14.0615C10.1309 12.25 11.4229 10.2129 12.5303 8.55859H12.6123V14.1436H9.05762Z"
          fill="white"
        />
      </svg>
    </div>
  );
}
